import { AutoComplete, Button, Form, Input, Select, Spin, Drawer } from "antd";
import axios from "axios";
import { debounce } from "lodash";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { authenticateToken } from "../../utils/auth";
import { getParamValue, jcTypeArray } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { useLocation } from "react-router";
import Empty from "../common/Empty";
import { responseNotification } from "../../utils/notify";
import { EditOutlined } from "@ant-design/icons";
import AddKeyword from "./AddKeyword";
import KeywordDetails from "./KeywordDetails";

const PopularKeywordList = (): ReactElement => {
  const [form] = Form.useForm();
  const [key, setKey] = useState("");
  const [limit, setLimit] = useState(20);
  const [status, setStatus] = useState("");
  const [type, setType] = useState("JC_MART");
  const [visible, setVisible] = useState(undefined);
  const router = useLocation();
  const page = getParamValue(router?.search, "page");

  const [selectedKey, setSelectedKey] = useState(undefined);
  const [selectedKeyForEdit, setSelectedKeyForEdit] = useState(undefined);

  const [keywordData, setKeywordData] = useState<any>({
    loading: false,
    item: [],
  });
  const [keywordOptions, setKeywordOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const getKeywords = useCallback(() => {
    try {
      setKeywordData({ loading: true, item: [] });

      const url =
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/keyword/popular/all?` +
        `page=${page || 0}` +
        `&limit=${limit || 16}` +
        (type ? `&type=${type}` : ``) +
        (key ? `&key=${key}` : ``);

      fetch(url, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setKeywordData({ loading: false, item: data });
        })
        .catch(() => {
          setKeywordData({ loading: true, item: [] });
        });
    } catch (error) {
      setKeywordData({ loading: true, item: [] });
      console.log(error, "error");
    }
  }, [limit, page, key, type]);

  const getKeywordOptions = useCallback(
    async (val) => {
      setKeywordOptions({ loading: false, list: [] });

      setKeywordOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/keyword/popular/all?page=0&limit=20` +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setKeywordOptions({
        loading: false,
        list: res?.data?.popularSearches?.map((keyword: { name: any }) => {
          return {
            value: keyword?.name,
            label: keyword?.name,
          };
        }),
      });
    },
    [status, type]
  );

  const fetchRef = useRef(null);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "keyword") getKeywordOptions(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 800);
  }, [getKeywordOptions, type]);

  useEffect(() => {
    form.resetFields(["keyword"]);
  }, [form, type]);

  useEffect(() => {
    getKeywords();
  }, [getKeywords]);

  const reseAllFieldData = () => {
    setKey("");
    setType("JC_MART");
    form.resetFields();
  };

  const onClose = () => {
    form.resetFields();
    setVisible(false);
    setSelectedKeyForEdit(undefined);
    setSelectedKey(undefined);
    getKeywords();
  };

  return (
    <React.Fragment>
      <div className="product-lists">
        <TopHeading
          {...keywordData?.data?.totalElements}
          refetch={getKeywords}
        />
        <section className="search_area">
          <Form form={form} className="search_form">
            <Form.Item name="type_search" initialValue={type}>
              <Select
                showSearch
                placeholder="Filter by Type"
                onChange={(val) => setType(val as string)}
              >
                <Select.Option value="">ALL TYPES</Select.Option>
                {Object.values(jcTypeArray)?.map((type, i) => (
                  <Select.Option value={type} key={i}>
                    {type.replace("_", " ")}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item name="product_search" initialValue={key} >
              <AutoComplete
                onSearch={(e) => handleSearch(e, "keyword")}
                onSelect={(val) => setKey(val.toString())}
                options={keywordOptions?.list}
                defaultActiveFirstOption={false}
                notFoundContent={
                  keywordOptions?.loading ? <Spin size="small" /> : null
                }
              >
                <Input.Search
                  size="large"
                  placeholder="Search by Keyword"
                  onSearch={(val) => {
                    setKey(val);
                  }}
                  enterButton
                  loading={keywordOptions.loading}
                  pattern={`[0-9]`}
                  maxLength={11}
                />
              </AutoComplete>
            </Form.Item>
          </Form>
          <div className="search_btn">
            <Button
              type="primary"
              size="large"
              danger
              onClick={reseAllFieldData}
            >
              Reset
            </Button>
          </div>
        </section>

        <div className="product-list-item-area white-bg section-padding-bottom">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    <div className="single-product-heading major">
                      <span>Keyword</span>
                    </div>
                    <div className="single-product-heading major">
                      <span>Type</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Status</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Action</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              {keywordData.loading ? (
                <Loading />
              ) : (
                <div className="col-lg-12 product-table">
                  <div className="product-table-area">
                    {keywordData.item?.popularSearches?.length ? (
                      keywordData?.item?.popularSearches?.map(
                        (keyword: any, index: number) => (
                          <React.Fragment key={index}>
                            <div
                              className="single-product-wrapper"
                              // onClick={() => setSelectedKey(keyword)}
                            >
                              <div className="single-product major">
                                <span className="name">{keyword?.name}</span>
                              </div>

                              <div className="single-product major">
                                <span className="name">
                                  {keyword?.type?.replace("_", " ")}
                                </span>
                              </div>

                              <div className="single-product">
                                <span
                                  className={`radius-btn ${
                                    keyword?.active ? "active" : "inactive"
                                  }-btn`}
                                >
                                  {keyword?.active ? "Active" : "Inactive"}
                                </span>
                              </div>

                              <div className="single-product">
                                <button
                                  className="btn btn-sm btn-warning mx-1"
                                  onClick={() => setSelectedKeyForEdit(keyword)}
                                >
                                  <EditOutlined />
                                </button>
                              </div>
                            </div>
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <Empty data="Products" />
                    )}
                  </div>
                </div>
              )}
            </div>
            <PaginationTwo
              {...keywordData.item}
              limit={limit}
              page={keywordData?.item?.currentPageNumber || 0}
            />
          </div>
        </div>
      </div>

      <Drawer
        title={selectedKeyForEdit ? "Edit Keyword" : "Keyword Details"}
        width={selectedKeyForEdit ? 500 : 600}
        onClose={onClose}
        visible={selectedKey || selectedKeyForEdit}
        bodyStyle={{ paddingBottom: 80 }}
        footer={
          <div
            style={{
              textAlign: "right",
            }}
          ></div>
        }
      >
        {selectedKeyForEdit ? (
          <AddKeyword
            visibleData={selectedKeyForEdit}
            onCloseMethod={onClose}
          />
        ) : (
          <KeywordDetails KeywordDetails={selectedKey} />
        )}
      </Drawer>
    </React.Fragment>
  );
};

export default PopularKeywordList;
